import React, { useState } from "react";
import {
  CardBanner,
  CardBannerNumber,
  CardBannerSubNumber,
  CardBannerIcon,
  CardBannerTitle,
  CardBannerWraper,
  CardBannerDivide,
  CardBannerSubBalanceTitle,
} from "./styles";
import {
  BalanceIcon,
  EyeIcon,
  IconHideAmountNew,
  NoEyeIcon,
  SubBalanceIcon,
} from "../../pages/wallet-list/styles";
import { useApp } from "../../contexts";

export const CardSlideHeader = ({
  title,
  balance,
  type,
  active,
  onClick,
  isMobile,
  infoIcon,
  bannerIcon,
  hasBalance = true,
  hasSubBalance = false,
  subBalance,
  balanceTitle,
  subBalanceTitle,
}) => {
  const [visible, setVisible] = useState(false);
  const { T } = useApp();

  const renderBalance = () => {
    return (
      <div className={`h-full flex flex-col gap-0 lg:gap-2
        ${hasBalance ? "pt-[5px] lg:pt-[15px]" : "justify-center pt-0 lg:pt-0"}
      `}>
          <CardBannerTitle className={`w-full lg:w-auto flex items-center gap-2 card-banner-title`}>
            {T(title)} {infoIcon}
          </CardBannerTitle>

          {hasBalance && <>
            <CardBannerNumber className="flex items-center card-banner-balance">
              {!visible ? (
                <IconHideAmountNew width={isMobile ? 80 : 150} />
              ) : (
                balance
              )}
              <BalanceIcon
                className="mb-1 card-banner-eye"
                onClick={(e) => {
                  e.stopPropagation();
                  setVisible(!visible);
                }}
              >
                {visible ? <EyeIcon /> : <NoEyeIcon />}
              </BalanceIcon>
            </CardBannerNumber>
          </>}
        </div>
    )
  };

  const renderBalanceWithSubBalance = () => {
    return (
      <div className="h-full lg:pt-[10px] flex flex-col gap-0 lg:gap-2">
          <CardBannerTitle className="w-full lg:w-auto flex items-center gap-2 card-banner-title">
            {T(title)} {infoIcon}
          </CardBannerTitle>

          <div className="flex justify-between">
            <div>
              <CardBannerSubBalanceTitle>
                {balanceTitle}
              </CardBannerSubBalanceTitle>
              <CardBannerSubNumber 
                className="flex items-center card-banner-balance"
              >
                {!visible ? (
                  <IconHideAmountNew width={isMobile ? 50 : 80} />
                ) : (
                  balance
                )}
              </CardBannerSubNumber>
            </div>

            <div className="mx-3 w-[1px] mt-[5px] lg:mt-[2px] lg:mb-[2px] bg-[#0000001a] card-banner-divide" />
            
            <div>
              <CardBannerSubBalanceTitle>
                {subBalanceTitle}
              </CardBannerSubBalanceTitle>
              <CardBannerSubNumber 
                className="flex items-center card-banner-balance"
              >
                {!visible ? (
                  <IconHideAmountNew width={isMobile ? 50 : 80} />
                ) : (
                  subBalance
                )}
              </CardBannerSubNumber>
            </div>

            <SubBalanceIcon
              className="card-banner-eye"
              onClick={(e) => {
                e.stopPropagation();
                setVisible(!visible);
              }}
            >
              {visible ? <EyeIcon /> : <NoEyeIcon />}
            </SubBalanceIcon>
          </div>
        </div>
    )
  }
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick?.();
    }
  }

  return (
    <CardBannerWraper
      className={active && "active"}
      onClick={() => onClick?.()}
      tabIndex="0"
      onKeyDown={handleKeyDown}
    >
      <CardBanner type={type}>
        <CardBannerIcon className="card-banner-icon flex-none w-8">
          {bannerIcon}
        </CardBannerIcon>
        <CardBannerDivide className="card-banner-divide" />
        {hasSubBalance ? renderBalanceWithSubBalance() : renderBalance()}
      </CardBanner>
    </CardBannerWraper>
  );
};
